import { connect } from 'react-redux';
import Profile from './profile'
import * as AC from '../../actions/actionCreators'

function mapStateToProps(state) { 
	return {
        profile: state.profile
}};

function mapDispatchToProps(dispatch) {
    return({
        logout: () => { dispatch(AC.ProfileLogout() ) },
    })
}

export default connect(mapStateToProps, mapDispatchToProps)(Profile);